export const reduxKey = '@@MURO';

//# sourceMappingURL=constants.js.map